// import { SafeHtmlPipe } from './../../../shared/pipes/strip-html.pipe';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { KnowledgeSectionRoutingModule } from './knowledge-section-routing.module';
import { NewsletterIdeaSidebarComponent } from './shared/newsletter-idea-sidebar/newsletter-idea-sidebar.component';
import { CaseStudyComponent } from './case-study/case-study.component';
import { CaseStudyDetailComponent } from './case-study-detail/case-study-detail.component';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { InterviewComponent } from './interview/interview.component';
import { InterviewDetailComponent } from './interview-detail/interview-detail.component';
import { NewsComponent } from './news/news.component';
// import { CarouselModule } from 'ngx-bootstrap/carousel';
import { ArticlesComponent } from './articles/articles.component';
import { ArticlesDetailComponent } from './articles-detail/articles-detail.component';
import { NgoOfMonthComponent } from './ngo-of-month/ngo-of-month.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgxSpinnerModule } from "ngx-spinner";
import { ModalModule} from 'ngx-bootstrap/modal';  
import { SlickModule } from 'ngx-slick';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { ShareIconsModule} from 'ngx-sharebuttons/icons'

@NgModule({
  declarations: [NewsletterIdeaSidebarComponent, CaseStudyComponent, CaseStudyDetailComponent, InterviewComponent, InterviewDetailComponent, NewsComponent, ArticlesComponent, ArticlesDetailComponent, NgoOfMonthComponent],
  imports: [
    CommonModule,
    KnowledgeSectionRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    PaginationModule.forRoot(),
    // CarouselModule.forRoot(),
    SharedModule,
    NgxSpinnerModule,
    SlickModule.forRoot(),
    ModalModule.forRoot(),
    ShareButtonsModule,
    ShareIconsModule
  ]
})
export class KnowledgeSectionModule { }
